import styles from '../EditWishlistModal.module.scss'

const SharingWishlistItem = (props) => {
  const {
    value = {
      email: '',
    },
  } = props
  const { email } = value

  return <span className={styles.emailSpan}>{email}</span>
}

export default SharingWishlistItem
